import { render, staticRenderFns } from "./faqDetail.vue?vue&type=template&id=ce877320&"
import script from "./faqDetail.vue?vue&type=script&lang=js&"
export * from "./faqDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports